import React from 'react';
import {
  Create,
  Edit,
  EditButton,
  Filter,
  maxLength,
  minLength,
  ReferenceField,
  ReferenceInput,
  required,
  SearchInput,
  SelectInput,
  TextField,
  TextInput,
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import TruncatedTextField from './TruncatedTextField';
import BulkDeleteButton from '../../components/BulkDeleteButton';
import ReferenceChild from '../../components/ReferenceChild';
import { perPage } from '../../helper';
import ListWithCSVImport from '../../components/ListWithCSVImport';

const BlurbFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

const listStyles = {
  nb_commands: { color: 'purple' },
};

export const BlurbList = withStyles(listStyles)(({ classes, ...props }) => (
  <div>
    <ListWithCSVImport
      {...props}
      filters={<BlurbFilter />}
      bulkActionButtons={<BulkDeleteButton />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={50}
    >
      <ZippityDatagrid>
        <TextField source="created_at" />
        <TextField source="modified_at" />
        <TextField source="name" />
        <ReferenceField
          source="inspection_id"
          reference="inspection"
          link="show"
          allowEmpty
        >
          <TextField source="inspection_name" />
        </ReferenceField>
        <TextField source="inspection_condition" />
        <TextField source="diagnostic_question" />
        <TruncatedTextField source="blurb" length={50} />
        <TextField source="number_of_times_used" />
        <EditButton />
      </ZippityDatagrid>
    </ListWithCSVImport>
    <p>
      These blurbs are available for the technicians to use in the Technician
      Mobile App -- either within the Health Check Inspections, or within the
      Diagnostic Question-and-Answer.
    </p>
  </div>
));

const editStyles = {};

const validateRequiredString = [required(), minLength(2), maxLength(63)];
const validateString = [minLength(2), maxLength(63)];
const validateBlurb = [required(), minLength(2), maxLength(1000)];

export const BlurbEdit = withStyles(editStyles)(({ classes, ...props }) => (
  <Edit undoable={false} {...props}>
    <ZippitySimpleForm>
      <TextInput validate={validateRequiredString} source="name" />
      <TextInput validate={validateRequiredString} source="created_by" />
      <ReferenceInput
        source="inspection_id"
        reference="inspection"
        sort={{ field: 'inspection_name', order: 'ASC' }}
        perPage={perPage}
      >
        <ReferenceChild
          {...props}
          optionText="inspection_name"
          source="inspection_id"
        />
      </ReferenceInput>
      <SelectInput
        source="inspection_condition"
        choices={[
          { id: 'GOOD', name: 'GOOD' },
          { id: 'FAIR', name: 'FAIR' },
          { id: 'POOR', name: 'POOR' },
          { id: 'DANGER', name: 'DANGER' },
        ]}
      />
      <TextInput
        multiline
        validate={validateString}
        source="diagnostic_question"
      />
      <TextInput multiline validate={validateBlurb} source="blurb" />
    </ZippitySimpleForm>
  </Edit>
));

export const BlurbCreate = withStyles(editStyles)(({ classes, ...props }) => (
  <Create {...props}>
    <ZippitySimpleForm>
      <TextInput validate={validateRequiredString} source="name" />
      <TextInput validate={validateRequiredString} source="created_by" />
      <ReferenceInput
        source="inspection_id"
        reference="inspection"
        sort={{ field: 'inspection_name', order: 'ASC' }}
        perPage={perPage}
      >
        <ReferenceChild
          {...props}
          optionText="inspection_name"
          source="inspection_id"
        />
      </ReferenceInput>
      <SelectInput
        source="inspection_condition"
        choices={[
          { id: 'GOOD', name: 'GOOD' },
          { id: 'FAIR', name: 'FAIR' },
          { id: 'POOR', name: 'POOR' },
          { id: 'DANGER', name: 'DANGER' },
        ]}
      />
      <TextInput
        multiline
        validate={validateString}
        source="diagnostic_question"
      />
      <TextInput multiline validate={validateBlurb} source="blurb" />
    </ZippitySimpleForm>
  </Create>
));
